import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import BasicTooltip from '../../Popover/BasicTooltip';
import { FirstTimeFlag } from '../../redux/firstTimeFlags';
import s from './NetworkBarFTUETooltip.scss';
var NetworkBarFTUETooltip = function (_a) {
    var className = _a.className, withCloseButton = _a.withCloseButton, placement = _a.placement, dropFirstTimeFlag = _a.dropFirstTimeFlag, hideFTUE = _a.hideFTUE;
    var t = useTranslation().t;
    useEffect(function () {
        dropFirstTimeFlag(FirstTimeFlag.IsNetworkbarNotUsed);
    }, [dropFirstTimeFlag]);
    return (React.createElement(BasicTooltip, { className: classnames(s['root'], className), withCloseButton: withCloseButton, placement: placement, secondaryPlacement: "start", onClose: function () { return hideFTUE(); } },
        React.createElement("img", { alt: t('networkBar.ftue.tooltip.title'), src: "https://st.deviantart.net/eclipse/global/svg/il79-welcome.svg", className: s['illustration'] }),
        React.createElement("div", { className: s['title'] }, t('networkBar.ftue.tooltip.title')),
        React.createElement("div", { className: s['text'] }, t('networkBar.ftue.tooltip.text'))));
};
NetworkBarFTUETooltip.displayName = 'NetworkBarFTUETooltip';
export default NetworkBarFTUETooltip;
//# sourceMappingURL=NetworkBarFTUETooltip.js.map